/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./SocialReddit.vue?vue&type=template&id=1d757d46&"
import script from "./SocialReddit.vue?vue&type=script&lang=js&"
export * from "./SocialReddit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports